import React from "react";
import VoucherStats from "./VoucherStats";
import { Card, CardBody, CardTitle } from 'reactstrap';

import IntlMessages from '../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../components/DatatablePagination';
const PopularAds = ({ statsData, data, labels }) => {
    return (<div>
        <div className="row">
            <div className="col-md-12 mb-4">
                <Card>
                    <div style={{ padding: '15px' }}>
                        <div className="float-left float-none-xs">
                            <div className="d-inline-block">
                                <h5 className="d-inline">
                                   Advertisements
                                </h5>
                                <span className="text-muted text-small d-block">
                                   Ads Impressions and Clicks
                                </span>
                            </div>
                        </div>
                    </div>
                    <CardBody>
                        <ReactTable
                            style={{ whiteSpace: 'normal' }}
                            data={data}
                            columns={labels}
                            defaultPageSize={5}
                            filterable={false}
                            showPageJump={true}
                            PaginationComponent={DataTablePagination}
                            showPageSizeOptions={true}
                        />
                    </CardBody>
                </Card>
            </div>            
        </div>

    </div >);
};
export default PopularAds;